import AddressDisplay from 'src/components/Review/AddressDisplay';
import TextDisplay from 'src/components/Review/TextDisplay';

/**PropertyInfo component displays the property information for a property or vehicle.
@component
@example
const info = {
serialNumber: '123456',
type: 'Residential',
address: {
street: '123 Main St',
city: 'New York',
state: 'NY',
zip: '10001',
},
}
return (
<PropertyInfo type="real" info={info} />
)
*/
export default function PropertyInfo({ className = '', info, type = '' }) {
  const fields = {
    real: [
      { field: 'Serial Number', value: info?.serialNumber },
      { field: 'Real Property Type', value: info?.type },
    ],
    personal: [
      { field: 'Account Number', value: info?.accountNo },
      { field: 'Personal Property Type', value: info?.type },
    ],
    greenbelt: [
      { field: 'Account Number', value: info?.accountNo },
      { field: 'Serial Number', value: info?.serialNumber },
    ],
    vehicle: [{ field: 'VIN (Vehicle Identification Number)', value: info?.vin }],
  };

  return (
    <div className={`flex flex-wrap gap-4 ${className}`}>
      {fields[type] &&
        fields[type].map(({ field, value }, index) => (
          <TextDisplay key={index} className="w-full" field={field} value={value} />
        ))}
      <AddressDisplay address={info?.address} />
    </div>
  );
}
